<!--
 * @Author: 付康 fukang@yuouhui.com
 * @Date: 2022-11-01 09:52:21
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-11-16 14:21:36
 * @FilePath: /wxkn-experience/src/components/miHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content">
    <div class="navi-box">
      <van-nav-bar title="经验派" />
    </div>
    <div class="select-box">
      <div class="tab-box">
        <div
          class="tab-item"
          v-for="item in menuOptions"
          :key="item.topMenuCode"
          @click="handleTabsChange(item)"
        >
          <div
            class="tab-title"
            :class="active == item.topMenuCode ? 'active' : ''"
          >
            <div>{{ item.name }}</div>
            <div class="item-icon">
              <van-icon
                name="fire"
                color="red"
                v-if="item.topMenuCode == 'REQUIRE'"
              />
            </div>
          </div>
          <div class="tab-line" v-if="active == item.topMenuCode"></div>
        </div>
      </div>
    </div>

    <div class="content-box" style="margin: 0 5px">
      <div v-if="active != 'REQUIRE'">
        <div class="swiper-box">
          <van-swipe autoplay="3000" indicator-color="#3d7eff"   height="150">
            <van-swipe-item v-for="item in bannerOptions" :key="item">
              <el-image :src="item.img" :fit="contain"></el-image>
            </van-swipe-item>     
          </van-swipe>
          <!-- <el-carousel indicator-position="" height="150px">
            <el-carousel-item v-for="item in bannerOptions" :key="item">
              <el-image :src="item.img" :fit="fill"></el-image>
            </el-carousel-item>
          </el-carousel> -->
        </div>
        <div class="menus-box">
          <div class="menu-item" @click="handleRZClick">
            <div class="menu-icon">
              <div class="label-tag">学长学姐</div>
              <img
                :src="require('@/assets/miImgs/imgs/menu-icon1.png')"
                alt=""
              />
            </div>
            <div>
              <div class="menu-title">立即认证</div>
            </div>
            <div>
              <div class="menu-des">成为"经验家"</div>
            </div>
          </div>
          <div class="menu-item" @click="handleLoginClick">
            <div class="menu-icon">
              <img
                :src="require('@/assets/miImgs/imgs/menu-icon2.png')"
                alt=""
              />
            </div>
            <div>
              <div class="menu-title">邀请赚钱</div>
            </div>
            <div>
              <div class="menu-des">邀请好友赚佣金</div>
            </div>
          </div>
          <div class="menu-item" @click="downLoadAction">
            <div class="menu-icon">
              <img
                :src="require('@/assets/miImgs/imgs/menu-icon3.png')"
                alt=""
              />
            </div>
            <div>
              <div class="menu-title">资料下载</div>
            </div>
            <div>
              <div class="menu-des">真题笔记在这里</div>
            </div>
          </div>
          <div class="menu-item" @click="gotoRequire">
            <div class="menu-icon">
              <img
                :src="require('@/assets/miImgs/imgs/menu-icon4.png')"
                alt=""
              />
            </div>
            <div>
              <div class="menu-title">需求广场</div>
            </div>
            <div>
              <div class="menu-des">发布需求寻找过来人</div>
            </div>
          </div>
        </div>
        <div class="more-box">
          <van-cell
            title="【经验家】推荐"
            :icon="require('@/assets/miImgs/imgs/xzxj.png')"
            value="查看更多"
            is-link
            :border="false"
            custom-style="padding-left: 0; padding-right: 0"
            @click.stop="showDialog = true"
          />
        </div>
        <div class="select-options">
          <div
            class="select-item"
            :class="queryParams.topMenuCode != 'PO' ? 'isgk' : ''"
            @click="gotoNationPage"
            v-if="queryParams.topMenuCode == 'LX'"
          >
            <label
              :style="
                queryParams.topMenuCode != 'PO' ? 'width:60px' : 'width:100px'
              "
            >
              {{
                !isEmptyString(queryParams.nation)
                  ? queryParams.nation
                  : "请选择国家/地区"
              }}
            </label>
            <img
              style="width: 12px; height: 8px"
              :src="require('@/assets/miImgs/imgs/select.png')"
              v-if="isEmptyString(queryParams.nation)"
            />
            <img
              style="width: 24px; height: 24px"
              :src="require('@/assets/miImgs/imgs/close.png')"
              v-if="!isEmptyString(queryParams.nation)"
              @click.stop="clearNationAction"
            />
          </div>
          <div
            class="select-item"
            :class="queryParams.topMenuCode != 'PO' ? 'isgk' : ''"
            @click.stop="gotoSchoolPage"
          >
            <label
              :style="
                queryParams.topMenuCode != 'PO' ? 'width:60px' : 'width:100px'
              "
            >
              {{
                !isEmptyString(queryParams.school)
                  ? queryParams.school
                  : "请选择学校"
              }}
            </label>
            <img
              style="width: 12px; height: 8px"
              :src="require('@/assets/miImgs/imgs/select.png')"
              v-if="isEmptyString(queryParams.school)"
            />
            <img
              style="width: 24px; height: 24px"
              :src="require('@/assets/miImgs/imgs/close.png')"
              v-if="!isEmptyString(queryParams.school)"
              @click.stop="clearSchoolAction"
            />
          </div>
          <div
            class="select-item"
            :class="queryParams.topMenuCode != 'PO' ? 'isgk' : ''"
            @click.stop="gotoMajorPage"
          >
            <label
              :style="
                queryParams.topMenuCode != 'PO' ? 'width:60px' : 'width:100px'
              "
            >
              {{
                !isEmptyString(queryParams.major)
                  ? queryParams.major
                  : "请选择专业"
              }}
            </label>
            <img
              style="width: 12px; height: 8px"
              :src="require('@/assets/miImgs/imgs/select.png')"
              v-if="isEmptyString(queryParams.major)"
            />
            <img
              style="width: 24px; height: 24px"
              :src="require('@/assets/miImgs/imgs/close.png')"
              v-if="!isEmptyString(queryParams.major)"
              @click.stop="clearMajorAction"
            />
          </div>
          <div
            class="select-item"
            :class="queryParams.topMenuCode != 'PO' ? 'isgk' : ''"
            v-if="queryParams.topMenuCode == 'GK'"
            @click.stop="showAreaPopup = true"
          >
            <label
              :style="
                queryParams.topMenuCode != 'PO' ? 'width:60px' : 'width:100px'
              "
            >
              {{
                !isEmptyString(queryParams.province)
                  ? queryParams.province
                  : "请选择生源地"
              }}
            </label>
            <img
              style="width: 12px; height: 8px"
              :src="require('@/assets/miImgs/imgs/select.png')"
              v-if="isEmptyString(queryParams.province)"
            />
            <img
              style="width: 24px; height: 24px"
              :src="require('@/assets/miImgs/imgs/close.png')"
              v-if="!isEmptyString(queryParams.province)"
              @click.stop="clearProvinceAction"
            />
          </div>
        </div>

        <van-list class="list-div" @load="onReachBottom">
          <van-empty
            img="search"
            :description="isLoading ? '暂无数据' : '正在加载'"
            v-if="dataList.length == 0"
          />
          <div
            class="list-item"
            v-for="item in dataList"
            :key="item.userId"
            @click.stop="handleShowInfo(item)"
          >
            <div class="avatar-box">
              <van-image width="50" height="50" round :src="item.userLogo" />
            </div>
            <div class="info-box">
              <div class="info-name-box">
                <div class="name-box">
                  <label class="name">{{ item.userName }}</label>
                  <img
                    style="width: 60px; height: 18px"
                    :src="require('@/assets/miImgs/imgs/renzhen.png')"
                  />
                  <div class="tag-province" v-if="item.province">
                    {{ item.province }}
                  </div>
                </div>
                <div class="ask-button" @click="handleShowInfo(item)">咨询TA</div>
              </div>
              <div class="tags">
                <div class="tag-item" v-if="!isEmptyString(item.school)">
                  {{ item.school || "" }}
                </div>
                <div class="tag-item" v-if="!isEmptyString(item.major)">
                  {{ item.major || "" }}
                </div>
                <div
                  class="tag-item"
                  v-if="!isEmptyString(item.edu) && active == 'PO'"
                >
                  {{ item.edu || "" }}
                </div>
                <div
                  class="tag-item"
                  v-if="!isEmptyString(item.inTime) && active == 'PO'"
                >
                  {{ item.inTime || "" }}
                </div>
              </div>
              <div style="display: flex; justify-content: flex-end"></div>

              <!-- <div class="desc" v-if="!$ComTools.isEmptyString(item.intro)">
                      {{ item.intro }}
                    </div> -->
            </div>
          </div>
        </van-list>
      </div>
      <div v-if="active == 'REQUIRE'">
        <div class="add-btn" @click="gotoAdd">
          <van-icon name="add" />
        </div>
        <van-empty
          img="search"
          description="暂无数据"
          v-if="requireList.length == 0"
        />
        <div class="list-demand">
          <div class="list-item" v-for="item in requireList" :key="item.id">
            <div class="mine-class" v-if="item.izMe == 'Y'">我发布的</div>
            <div>
              <van-field
                :value="item.title"
                name="主题"
                label="主题"
                disabled
              />
              <van-field
                :value="item.content"
                type="textarea"
                name="需求详情"
                label="需求详情"
                disabled
              />
              <van-field
                :value="item.money"
                type="digit"
                name="费用（元）"
                label="费用（元）"
                disabled
              />
              <div class="limited-box" v-if="item.requireTermsList.length > 0">
                <div class="limited-label">谁可以接单：</div>
                <div>
                  <van-field
                    :value="item.requireTermsList[0].school"
                    name="大学"
                    disabled
                    v-if="!isEmptyString(item.requireTermsList[0].school)"
                  />
                  <van-field
                    :value="getServiceName(item.requireTermsList[0].edu)"
                    name="学历"
                    disabled
                    v-if="!isEmptyString(item.requireTermsList[0].edu)"
                  />
                  <van-field
                    :value="item.requireTermsList[0].inTime"
                    name="入学年份"
                    disabled
                    v-if="!isEmptyString(item.requireTermsList[0].inTime)"
                  />
                  <van-field
                    :value="item.requireTermsList[0].major"
                    name="专业"
                    disabled
                    v-if="!isEmptyString(item.requireTermsList[0].major)"
                  />
                </div>
              </div>
              <div class="actions">
                <div
                  class="btn"
                  v-if="item.izMe == 'Y'"
                  @click="removeRequireAction(item)"
                >
                  撤单
                </div>
                <div class="btn" @click="takeRequireAction(item)" v-else>
                  接单
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--通用下拉框-->
    <van-popup
      :show="showAreaPopup"
      position="bottom"
      custom-style="height: 50%;"
      round
      @close="showAreaPopup = false"
    >
      <van-area
        title="选择生源地"
        :area-list="areaList"
        :columns-num="1"
        @confirm="areaAction"
        @cancel="showAreaPopup = false"
      />
    </van-popup>

    <van-action-sheet
      v-model="showDialog"
      closeable
      title="使用微信扫码，进入小程序，体验更多功能"
    >
      <div class="popup-box">
        <div class="popup-title">
          <!-- 使用微信扫码，进入小程序，体验更多功能 -->
          <div class="popup-dsc">长按下载二维码</div>
        </div>
        <div class="qr-code-box">
          <MinProgram :title="''" :subTitle="''"></MinProgram>
          <el-button type="primary" plain @click="frontDownload"
            >本地下载</el-button
          >
        </div>
      </div>
    </van-action-sheet>

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    </van-pull-refresh>
  </div>
</template>

<script>
import util from "@/util/util";
import cryptoDES from "@/util/cryptoDES";
import MinProgram from "@/components/MinProgram";

const initData = {
  pageNo: 0,
  pageSize: 10,
  topMenuCode: "",
  baseServiceId: "",
  school: "",
  major: "",
  desc: "",
  province: "",
  nation: "",
};

export default {
  data() {
    return {
      isLoading: false,
      areaList: [],
      showAreaPopup: false,
      swiperConfig: {
        indicatorDots: true,
        autoplay: true,
        interval: 5000,
        duration: 1000,
      },
      active: "PO",
      menuOptions: [],
      bannerOptions: [],

      isFollow: false,
      queryParams: initData,
      dataList: [],
      userInfo: {
        userID: "",
      },
      requireList: [],
      noRequire: false,
      noData: false,
      serviceTypes: [],
      showDialog: false,
    };
  },
  components: {
    MinProgram,
  },

  props: {
    schoolData: {
      type: Object,
      default: () => {},
    },
    majorData: {
      type: Object,
      default: () => {},
    },
    countryData: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.queryParams.pageNo = 0;
    // if (!this.isEmptyString(this.$cache.school.id)) {
    //     this.schoolData = this.$cache.school;
    // }

    // if (!this.isEmptyString(this.$cache.major.id)) {
    //     this.majorData = this.$cache.major;
    // }

    // if (!this.isEmptyString(this.$cache.nation.id)) {
    //     this.countryData = this.$cache.nation;
    // }
    this._topSection();
    this.dicItem();
  },
  watch: {
    schoolData(v, o) {
      if (v.id != o.id) {
        this.clearMajorAction();
        this.queryParams.school = v.name;
        this.queryParams.pageNo = 1;
        this.dataList = [];
        this._getListData();
      }
    },
    countryData(v, o) {
      if (v.id != o.id) {
        this.clearSchoolAction();
        this.queryParams.nation = v.name;
        this.queryParams.pageNo = 1;
        this.dataList = [];
        this._getListData();
      }
    },
    majorData(v, o) {
      if (v.id != o.id) {
        this.queryParams.major = v.name;
        this.queryParams.pageNo = 1;
        this.dataList = [];
        this._getListData();
      }
    },
  },
  methods: {
    //js
    frontDownload() {
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = "https://cdn.kudianxue.cn/temp/20221115111435_1668482127594.jpg"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      console.log("a.href", a.href);
      a.download = "qrcode.jpg"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    clearSchoolAction() {
      this.queryParams.school = "";
      this.queryParams.major = "";
      this.queryParams.pageNo = 1;
      this.dataList = [];
      this.schoolData = {};
      this.$cache.school = {};
      this.majorData = {};
      this.$cache.major = {};
      this._getListData();
    },
    clearMajorAction() {
      this.queryParams.major = "";
      this.queryParams.pageNo = 1;
      this.dataList = [];
      this.majorData = {};
      this.$cache.major = {};
      this._getListData();
    },
    clearNationAction() {
      this.queryParams.nation = "";
      this.dataList = [];
      this.countryData = {};
      this.$cache.nation = {};
      this.queryParams.school = "";
      this.queryParams.major = "";
      this.queryParams.pageNo = 1;
      this.dataList = [];
      this.schoolData = {};
      this.$cache.school = {};
      this.majorData = {};
      this.$cache.major = {};
      this._getListData();
    },

    handleShowInfo(item) {

      let query = {
        id: cryptoDES.encrypt(item.userId),
        code: this.active,
      };
      this.$router.push({
        path: "miuser/detail",
        query: query,
      });
    },
    gotoSchoolPage() {
      if (this.queryParams.topMenuCode == "LX") {
        if (!this.countryData.id) {
          return this.$notify({
            title: "错误",
            message: "请选择国家/地区",
            type: "error",
          });
        }

        let query = {
          code: cryptoDES.encrypt(this.queryParams.topMenuCode),
          id: this.countryData.id,
          status: "search",
        };
        this.$router.push({
          path: "mi/schools",
          query: query,
        });
      } else {
        let query = {
          code: cryptoDES.encrypt(this.queryParams.topMenuCode),
          status: "search",
        };
        this.$router.push({
          path: "mi/schools",
          query: query,
        });
      }
    },
    gotoNationPage() {
      let query = {
        code: cryptoDES.encrypt(this.queryParams.topMenuCode),
      };
      this.$router.push({
        path: "mi/countrys",
        query: query,
      });
    },
    gotoMajorPage() {
      if (this.queryParams.topMenuCode == "LX") {
        if (!this.countryData.id) {
          return this.$notify({
            title: "错误",
            message: "请选择国家/地区",
            type: "error",
          });
        }
      }
      if (!this.schoolData.id) {
        return this.$notify({
          title: "错误",
          message: "请选择学校",
          type: "error",
        });
      }

      let query = {
        code: cryptoDES.encrypt(this.queryParams.topMenuCode),
        id: this.schoolData.id,
      };
      this.$router.push({
        path: "mi/majors",
        query: query,
      });
    },

    gotoNationPage() {
      let query = {
        status: "search",
      };
      this.$router.push({
        path: "mi/countrys",
        query: query,
      });
    },
    gotoRequire() {
      this.showDialog = true;
    },
    downLoadAction() {
      this.showDialog = true;
    },
    handleLoginClick() {
      this.showDialog = true;
    },
    handleRZClick() {
      this.showDialog = true;
    },
    onReachBottom() {
     
      if (!this.isNoData) {
          this.queryParams.pageNo += 1;
          if (this.queryParams.pageNo > 1) {
              this._getListData();
          }
      }
    },
    _getListData() {
      this.queryParams.topMenuCode = this.active;
      let that = this;
      if (this.active == "REQUIRE") {
        util
          .axiosFun(
            that,
            "/xzxj/api/square/should/requireList",
            this.queryParams
          )
          .then((res) => {
            this.isLoading = true;

            if (res.code == 200) {
              if (this.queryParams.pageNo == 1) {
                this.requireList = res.result.records || [];
              } else {
                this.requireList = [...this.requireList, ...res.result.records];
              }
              if (this.requireList.length == res.total) {
                this.noRequire = true;
              }
            }
          });
      } else {
        util
          .axiosFun(that, "/xzxj/api/page/indexSearch", this.queryParams)
          .then((res) => {
            this.isLoading = true;
            if (this.queryParams.pageNo == 1) {
              this.dataList = res.records || [];
            } else {
              let list = res.records || [];
              this.dataList = [...this.dataList, ...list];
            }
            this.isNoData = this.dataList.length >= res.total;
          });
      }
    },
    _topSection() {
      let that = this;
      util
        .axiosFun(that, "/xzxj/api/page/topSection", this.queryParams)
        .then((res) => {
          let aTmp = res || [];
          let aTmp1 = [];
          for (let i = 0; i < aTmp.length; i++) {
            let obj = aTmp[i];
            aTmp1.push(obj);
          }
          this.menuOptions = aTmp1;
          if (this.menuOptions.length > 0) {
            this.active = this.menuOptions[0].topMenuCode;
            this.pageBannerAction(this.active);
            this._getListData();
          }
        });
    },
    async dicItem() {
      let that = this;
      let para = new URLSearchParams();
      para.append("dicCode", "XZXJ_DEGREE");
      let oResult = await util.axiosFun(
        that,
        "/xzxj/api/page/dicItem",
        para,
        "application/x-www-form-urlencoded"
      );
      this.serviceTypes = oResult.XZXJ_DEGREE || [];
    },
    onRefresh() {
      this.isLoading = false;
    },
    isEmptyString(data) {
      if (typeof data === "undefined") return true;
      if (data === "") return true;
      if (data === null) return true;
      if (data === "null") return true;
      if (data == "undefined") return true;
      if (data.length > 0 && data.trim() == "") return true;
      return false;
    },
    handleTabsChange(e) {
      this.active = e.topMenuCode;
      if (this.active != "REQUIRE") {
        this.isNoData = false;
        this.dataList = [];
        this.queryParams.pageNo = 1;
        this.clearSchoolAction();
        this.clearNationAction();
        this._getListData();
        this.pageBannerAction(this.active);
      }
    },
    pageBannerAction(topMenu) {
      let that = this;
      let para = new URLSearchParams();
      para.append("topMenu", topMenu);
      util
        .axiosFun(
          that,
          "/xzxj/api/page/banner",
          para,
          "application/x-www-form-urlencoded"
        )
        .then((res) => {
          that.bannerOptions = res;
        });
    },
    handleTabsChange(e) {
      this.active = e.topMenuCode;
      if (this.active != "REQUIRE") {
        this.isNoData = false;
        this.dataList = [];
        this.queryParams.pageNo = 1;
        this.clearSchoolAction();
        this.clearNationAction();
        this._getListData();
        this.pageBannerAction(this.active);
      }
    },
    clearSchoolAction() {
      this.queryParams.school = "";
      this.queryParams.major = "";
      this.queryParams.pageNo = 1;
      this.dataList = [];
      this.schoolData = {};
      this.$cache.school = {};
      this.majorData = {};
      this.$cache.major = {};
      this._getListData();
    },
    clearMajorAction() {
      this.queryParams.major = "";
      this.queryParams.pageNo = 1;
      this.dataList = [];
      this.majorData = {};
      this.$cache.major = {};
      this._getListData();
    },
    clearNationAction() {
      this.queryParams.nation = "";
      this.dataList = [];
      this.countryData = {};
      this.$cache.nation = {};
      this.queryParams.school = "";
      this.queryParams.major = "";
      this.queryParams.pageNo = 1;
      this.dataList = [];
      this.schoolData = {};
      this.$cache.school = {};
      this.majorData = {};
      this.$cache.major = {};
      this._getListData();
    },
    getServiceName(value) {
      if (this.isEmptyString(value)) {
        return "";
      }
      let sName = "";
      for (let i = 0; i < this.serviceTypes.length; i++) {
        let obj = this.serviceTypes[i];
        if (obj.value == value) {
          sName = obj.text;
          break;
        }
      }
      return sName;
    },
    bannerTapAction() {
      this.showDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.van-pull-refresh {
  min-height: 100%;
}

.menus-box {
  display: flex;
  justify-content: space-between;
  .menu-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .label-tag {
      position: absolute;
      left: 50%;
      top: 0;
      background: #ffd222;
      border-radius: 2px;
      z-index: 2;
      font-size: 10px;
      text-align: center;
      line-height: 16px;
      width: 50px;
      height: 16px;
    }
    .menu-icon {
      width: 50px;
      height: 50px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .menu-title {
      margin-top: 8px;
      font-size: 13px;
      font-weight: 600;
    }
    .menu-des {
      font-size: 10px;
      color: #666;
    }
  }
}

.tab-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  padding: 10px 10px 0 10px;
  .tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: relative;
    cursor: pointer;
    .tab-title {
      color: #646566;
      font-size: 14px;
      display: flex;
      &.active {
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .item-icon {
      margin-top: -8px;
      font-size: 14px;
    }
    .tab-line {
      height: 3px;
      width: 30px;
      background-color: #3d7eff;
      margin-top: 8px;
      border: 2px;
    }
  }
}

/deep/ .van-tag {
  display: flex;
}

.content {
  
  min-height: 100%;
  padding-bottom: 100px;
  padding-top: 95px;
 
  // touch-action: pan-y;
  overflow-x: hidden;
  .select-box {
    background: #fff;
    width: 100%;
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  .swiper-box {
    width: 100%;
    height: 150px;
    padding: 10px 0;
    .swiper {
      width: 100%;
      height: 100%;
      swiper-item {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        .swiper-view {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          overflow: hidden;
        }
      }
    }
  }
}

.renzheng-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  .renzheng-item {
    width: 48%;
    height: 100px;
    background: linear-gradient(169deg, #7ba7ff 0%, #3d7eff 100%);
    border-radius: 8px;
    position: relative;
    .tips-box {
      position: absolute;
      left: 10px;
      top: 15px;
      bottom: 10px;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
      }
      .button {
        background: #ffffff;
        border-radius: 14px;
        width: 80px;
        padding: 5px 0;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
      }
      .logo-box {
        position: absolute;
        bottom: 0;
        right: 10px;
        width: 45px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .yaoqing-item {
    width: 48%;
    height: 100px;
    background: linear-gradient(166deg, #fa8f67 0%, #fa5a4d 100%);
    border-radius: 8px;
    position: relative;
    .tips-box {
      position: absolute;
      left: 10px;
      top: 15px;
      bottom: 10px;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
      }
      .button {
        background: #ffffff;
        border-radius: 14px;
        width: 80px;
        padding: 5px 0;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
      }
      .logo-box {
        position: absolute;
        bottom: 0;
        right: 10px;
        width: 50px;
        height: 45px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.more-box {
  padding: 5px 0;
}

.select-options {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .select-item {
    height: 18px;
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    color: #999999;
    cursor:pointer;

    label {
      height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .isgk {
    width: 32% !important;
  }
}

.list-div {
  width: 100%;
  padding: 5px 0;
  margin-top: 10px;
  .list-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    height: 50px;
    padding: 15px 10px;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    .info-box {
      width: calc(100% - 60px);
      .info-name-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .name-box {
          display: flex;
          align-items: center;
          .name {
            max-width: 75px;
            height: 25px;
            line-height: 25px;
            font-size: 14px;
            font-weight: 600;
            color: #1a1a1a;
            margin-right: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .tags {
        display: flex;
        align-items: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .tag-item {
          font-size: 12px;
          font-weight: 500;
          color: #666666;
          line-height: 14px;
          margin-right: 10px;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            top: 1px;
            bottom: 1px;
            right: -5px;
            width: 1px;
            background-color: #666666;
          }
          &:last-child {
            margin-right: 0;
            &::after {
              content: none;
            }
          }
        }
      }
      .desc {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        font-weight: 500;
        color: #999999;
        margin-top: 10px;
      }
    }
  }
}

.list-demand {
  padding: 10px;
  margin-top: 10px;
  .list-item {
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    border: solid 1px #ebebeb;
    .mine-class {
      font-size: 12px;
      color: #3d7eff;
    }
    .limited-box {
      display: flex;
    }
    .limited-label {
      color: #333;
      font-weight: 600;
      font-size: 15px;
      margin-left: 15px;
      line-height: 30px;
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      .btn {
        color: #ffffff;
        background: #3d7eff;
        padding: 5px 30px;
        border-radius: 20px;
      }
    }
    /deep/.van-field__label {
      color: #333;
      font-size: 15px;
      font-weight: 600;
    }
    /deep/.van-field__control--disabled {
      color: #333333;
    }
  }
}

.add-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 60px;
  right: 15px;
  font-size: 50px;
  color: #3d7eff;
  z-index: 9999;
}

.ask-button {
  background-color: #3d7eff;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  padding: 3px 12px;
  text-align: center;
  border-radius: 15px;
}

.tag-province {
  padding: 2px 5px;
  background: #07c160;
  font-size: 10px;
  color: #fff;
  max-width: 50px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 10px;
  border-radius: 1px;
}

.navi-box {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
}

.popup-box {
  /* height: 100%; */
  .popup-title {
    font-size: 15px;
    text-align: center;
  }
  .popup-dsc {
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 10px;
  }
}

.qr-code-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/MiHome.vue